import { render } from "./inventorymodel.vue?vue&type=template&id=6314d6bf"
import script from "./inventorymodel.vue?vue&type=script&lang=js"
export * from "./inventorymodel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__